import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 7 5 5-5 5V7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 7-5 5 5 5V7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 14v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FlipHorizontal2";
const FlipHorizontal2 = memo(themed(Icon));
export {
  FlipHorizontal2
};
//# sourceMappingURL=flip-horizontal-2.js.map
